import Repository from '../Repository';

export default {

	getMarkingTypes() {
		var response = Repository.get('MarkingType/GetMarkingTypes', {});
		return response;
	}
	
}
